<template>
    <Sidebar :is_empty="true" />
    <div class="content reset-password-content">
        <div class="inner">
            <Header :title="title" :top_text="top_text" :text="text" />
            <div class="result-content" v-if="is_success">
                <h2 class="success">Your password has been updated!</h2>
                <!-- <p>Check your email and follow the instructions to <br>reset your password</p> -->
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" to="/login">Sign in</Button>
                    <!-- <p><router-link to="/login">Return to Sign in</router-link></p> -->
                </div>
            </div>
            <Form v-else :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="form-wrap"
                :class="[{ 'is-loading': is_loading }]" :need_error="true">
                <Field type="password" k="password" placeholder="Password" :error_msg="errors.password"
                    :is_success="success.password" @update="update" :no_show_err_msg="true" :handle_success="value_is_err.password"/>
                <Field type="password" k="repeat_password" placeholder="Repeat password" :error_msg="errors.repeat_password"
                    :is_success="success.repeat_password" @update="update" :no_show_err_msg="true" :handle_success="value_is_err.repeat_password"/>
                <p v-if="is_error" v-html="error_msg" class="error-msg"></p>
                <CheckFieldText :check_password_text="check_password_text" :is_error="is_error" />

                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit">Submit</Button>
                </div>
            </Form>

        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Field from '@/components/ui/Field.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Button from '@/components/ui/Button.vue';
import Form from '@/components/ui/Form.vue';


import Header from '@/components/login/Header.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);
import 'vue-advanced-cropper/dist/style.css';
import CheckFieldText from '@/components/ui/CheckFieldText.vue';

export default {
    name: 'reset-password',

    data() {
        return {
            top_text: 'Welcome!',
            title: 'Create new password',
            text: '',

            is_error: false,
            error_msg: '',
            is_success: false,
            schema: yup.object().shape({
                password: yup.string()
                    .password()
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .min(14, 'Must be at least 14 characters')
                    .required('The password can’t leave as blank'),

                repeat_password: yup.string()
                    .oneOf(
                        [yup.ref('password'), null],
                        'Passwords must match'
                    )
                    .password()
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .min(14, 'Must be at least 14 characters')
                    .required('The repeat password can’t leave as blank'),
            }),


            values: {
                password: '',
                repeat_password: '',
            },

            value_is_err: {
                password: true,
                repeat_password: true,
            },


        }
    },

    components: {
        Header,
        Sidebar,
        Form,
        Field,
        Checkbox,
        Button,
        CheckFieldText,
    },

    computed: {
        check_password_text() {
            return [
                {
                    text: 'Must be at least 14 characters',
                    is_correct: this.values['password'].length >= 14
                },
                {
                    text: 'Must have a number and special character',
                    is_correct: this.isValidPassword(this.values['password'])
                },
                {
                    text: 'Must contain at least 1 uppercase letter',
                    is_correct: this.isValidUppercasePassword(this.values['password'])
                },
                {
                    text: 'Password match',
                    is_correct: this.values['password'] && this.values['password'] == this.values['repeat_password']
                },
            ]
        },
    },

    methods: {
        isValidPassword(password) {
            const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?]).+$/;
            return regex.test(password);
        },
        isValidUppercasePassword(password) {
            const regex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
            return regex.test(password);
        },
        update(obj) {
            
            if (obj.val) {
                this.error_msg = '';
                this.is_error = false;
            }

            Object.keys(this.values).forEach(key => {
                if (key === obj.key) {
                    this.values[key] = obj.val;
                    this.validate(key);
                }
            });
        },

        //Listening to the input box being typed.
        validate(field) {
            return this.schema
                .validateAt(field, this.values)
                .then(() => {
                    this.is_error = false;
                    this.value_is_err[field] = false;
                })
                .catch((err) => {
                    //console.log('err', err.message)
                });
        },


        submit(val) {
            if (!val) {
                this.is_error = true;
            } else {
                this.is_error = false;
                this.error_msg = '';
                this.is_loading = true;
                this.$ajax('/forget-password/reset-password', {
                    method: 'post',
                    data: {
                        password: this.values.password,
                        confirm_password: this.values.repeat_password,
                        u: this.$route.query.u,
                        k: this.$route.query.k,
                    },
                }).then(res => {
                    this.is_loading = false;
                    this.is_success = true;
                    this.title = '';

                }).catch(err => {
                    this.is_loading = false;

                    if (err && err.response && err.response.data.data) {
                        this.is_error = true;
                        this.error_msg = err.response.data.data.message;
                    }
                });
            };
        },
    },
};
</script>

<style lang="scss">
.reset-password-content {
    display: flex;
    align-items: center;
    justify-content: center;

    // &.is-loading {
    //     .form-wrap,
    //     .code-box {
    //         opacity: .5;
    //         pointer-events: none;
    //     }
    // }


    .result-content {
        margin: 40px 0;
        text-align: center;
        color: var(--black-90);

        h2 {
            font: var(--font-demi-20);
            color: var(--green);
            margin-bottom: 12px;
        }

    }

    .form-wrap {
        &.full-width {
            width: 480px;

        }

        &.is-loading {
            opacity: .5;
            pointer-events: none;
        }

        &.is-error {

            .ui-input .ui-input--wrap select,
            .ui-input .ui-input--wrap input,
            .ui-input .ui-input--select select,
            .ui-input .ui-input--select input,
            .ui-input .ui-input--icon-wrap {
                border-color: var(--alert) !important;
            }

        }

        .error-msg {
            margin: 4px 0 0;
            font-size: 12px;
            color: var(--alert);

        }

        .ui-input>label {
            &::after {
                content: ' *';
                color: var(--alert);
            }
        }

        .ui-input.not-required>label {
            &::after {
                display: none;
            }
        }

        .two-cloumn {
            display: flex;

            .ui-input {
                width: calc(50% - 8px);

                &:nth-child(1) {
                    margin-right: 8px;
                    margin-bottom: 0;
                }

                &:nth-child(2) {
                    margin-left: 8px;
                    margin-bottom: 0;
                }
            }
        }
    }

    .submit-wrap {
        margin: 44px 16px;
        text-align: center;

        .ui-button {
            display: block;
            width: 180px;
            text-align: center;
            margin: 0 auto 16px;
        }

        a {
            font: var(--font-fg-12);
            color: var(--dark-blue);
        }
    }

    .login-header {
        max-width: 360px;
        margin-bottom: 46px;

        p {
            margin-top: 5px;
            font-size: 14px;
        }
    }

}</style>